<template>
    <div v-if="panel_required" class="designeroption" :data-designer-component-id="component_id">
        <h3> {{ title }} </h3>
        <div class="stylesoption">
            <div class="form-group mb-3">
                <select :id="'question--' + component_id" class="form-control" v-model="selected_font" v-if="!loading">
                    <option v-for="font in available_fonts" :value="font">{{ font }}</option>
                </select>
            </div>
            <div class="form-group" v-show="selected_font === 'Other'">
                <label>Please Specify</label>
                <input type="text" v-model="localTarget" id="glass_font" class="form-control" :readonly="selected_font !== 'Other'">
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question
        ],
        data() {
            return {
                available_fonts: [
                    'Times New Roman',
                    'Arial',
                    'Other'
                ],
                selected_font: 'Times New Roman'
            }
        },
        props: {
            title: {
                default(){
                    return 'Glass Font';
                }
            },
            component_id: {
                default(){
                    return 'glass_font';
                }
            },
            glassDesign: {
                required: true,
            },
            glassText: {
                required: false,
                default(){
                    return '';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.glassDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/glass-font?glass_design=' + this.glassDesign;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.glassDesign;
            },
            panel_required(){
                return this.option_list && this.option_list.has_font_option != false;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options(()=>{
                    this.setFontDefault();
                });
            },
            selected_font: function () {
                this.localTarget = this.selected_font;
            },
        },
        methods: {
            setFontDefault() {
                this.localTarget = this.available_fonts[0];
            }
        },
    }
</script>
